import React from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonTableList = (cols) => {
  const { count } = cols;
  return (
    <tr className="list w-full">
      {Array(count)
        .fill()
        .map((item, index) => (
          <td className=" px-4 py-4" key={index}>
            <p width={`100%`} className="card-channel">
              <Skeleton />
            </p>
          </td>
        ))}
    </tr>
  );
};

export default SkeletonTableList;
